<template>
  <div
    class="speed-box"
    :class="{
      'speed-box__h5': isH5,
      'speed-box__h5-landscape': isLandscape,
    }"
  >
    <span class="speed-btn" @click="toggleSpeed">
      {{ speedLabel }}
    </span>
    <div class="speed-control" v-if="isShow">
      <span
        @click="changeSpeed(item)"
        class="speed-label"
        :class="{ active: item.value === speed }"
        v-for="item in speedList"
        :key="item.value"
      >
        {{ item.label }}
      </span>
    </div>
  </div>
</template>

<script>
import { isH5, isMobile } from "@saas/components/src";
export default {
  props: {
    value: {
      type: Number,
      default: 1,
    },
    isLandscape: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      speed: 1, // 初始音量值
      isShow: false,
      speedList: [
        {
          label: "2.0X",
          value: 2,
        },
        {
          label: "1.5X",
          value: 1.5,
        },
        {
          label: "1.25X",
          value: 1.25,
        },
        {
          label: "1.0X",
          value: 1,
        },
        {
          label: "0.75X",
          value: 0.75,
        },
        {
          label: "0.5X",
          value: 0.5,
        },
      ],
      isH5: isMobile(),
    };
  },
  watch: {
    value: {
      handler(newValue) {
        if (newValue) {
          this.speed = newValue;
        } else {
          this.speed = 1;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    // 监听页面点击其他地方关闭音量控制
    document.addEventListener("click", this.clickOutside);
  },
  beforeDestroy() {
    // 移除页面点击事件监听
    document.removeEventListener("click", this.clickOutside);
  },
  computed: {
    speedLabel() {
      return (
        this.speedList.filter((item) => {
          return item.value === this.speed;
        })[0]?.label || ""
      );
    },
  },
  methods: {
    // 监听页面点击事件
    clickOutside(event) {
      const target = event.target;
      if (!this.$el.contains(target)) {
        this.isShow = false;
      }
    },
    onVolumeChange(event) {
      this.volume = event.target.value;
      this.$emit("change", this.volume, this.volumePercentage);
      this.$emit("input", this.volume);
      // 在这里处理音量变化事件，例如更新音量设置
    },
    toggleSpeed() {
      this.isShow = !this.isShow;
    },
    changeSpeed(item) {
      this.speed = item.value;
      this.isShow = false;
      this.$emit("change", this.speed);
      this.$emit("input", this.speed);
    },
    // 判断是否手机端并且横屏
    // isLandscape() {
    //   if (isMobile()) {
    //     return window.innerWidth > window.innerHeight;
    //   } else {
    //     return false;
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
.speed-box {
  position: relative;
  .speed-btn {
    display: block;
    font-size: 16px;
    color: #ffffff;
    font-weight: 500;
    line-height: 1;
    cursor: pointer;
    white-space: nowrap;
  }
  .speed-control {
    position: absolute;
    top: -348px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    flex-direction: column;
    background: rgba(13, 15, 20, 0.8);
    border-radius: 16px;
    padding: 6px 0;
    width: 192px;
    height: 300px;
    .speed-label {
      margin-top: 4px;
      padding-left: 33px;
      font-size: 16px;
      width: 175px;
      height: 44px;
      line-height: 44px;
      border-radius: 12px;
      font-weight: 600;
      font-size: 18px;
      color: #ffffff;
      cursor: pointer;
      &:first-child {
        margin-top: 0;
      }
      &:hover {
        background: rgba(81, 88, 103, 0.7);
      }
      &.active {
        color: rgba(0, 200, 157, 1);
      }
    }
  }
}
.speed-box__h5 {
  position: relative;
  .speed-btn {
    display: block;
    width: 1.0133rem;
    font-size: 0.4rem;
    color: #ffffff;
    line-height: 0.56rem;
    cursor: pointer;
  }
  .speed-control {
    position: absolute;
    top: -3rem;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    flex-direction: column;
    background: rgba(13, 15, 20, 0.8);
    border-radius: 0.2133rem;
    padding: 0.0625rem 0;
    width: 1.4rem;
    height: 2.8rem;
    .speed-label {
      margin-top: 0.025rem;
      padding-left: 0.1875rem;
      width: 1.0938rem;
      line-height: 0.4rem;
      line-height: 0.4rem;
      border-radius: 0.075rem;
      font-weight: 600;
      font-size: 0.2133rem;
      color: #ffffff;
      cursor: pointer;
      &:first-child {
        margin-top: 0;
      }
      &:hover {
        background: rgba(81, 88, 103, 0.7);
      }
      &.active {
        color: rgba(0, 200, 157, 1);
      }
    }
  }
}
.speed-box__h5-landscape {
  position: relative;
  .speed-btn {
    display: block;
    width: 0.5rem;
    font-size: 0.1875rem;
    color: #ffffff;
    line-height: 0.25rem;
    cursor: pointer;
  }
  .speed-control {
    position: absolute;
    top: -2.3rem;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    flex-direction: column;
    background: rgba(13, 15, 20, 0.8);
    border-radius: 16px;
    padding: 0.0625rem 0;
    width: 1.2rem;
    height: 1.875rem;
    .speed-label {
      margin-top: 0.025rem;
      padding-left: 0.1875rem;
      width: 1.0938rem;
      height: 0.25rem;
      line-height: 0.25rem;
      border-radius: 0.075rem;
      font-weight: 600;
      font-size: 0.125rem;
      color: #ffffff;
      cursor: pointer;
      &:first-child {
        margin-top: 0;
      }
      &:hover {
        background: rgba(81, 88, 103, 0.7);
      }
      &.active {
        color: rgba(0, 200, 157, 1);
      }
    }
  }
}
// ========== PAD 适配（768px ~ 1140px）：放大倍速按钮方便触摸点击 ==========
@media screen and (min-width: 768px) and (max-width: 1140px) {
  // --- 桌面浏览器窄窗口 ---
  .speed-box:not(.speed-box__h5):not(.speed-box__h5-landscape) {
    .speed-btn {
      width: 68px;
      font-size: 22px;
      line-height: 36px;
    }
    .speed-control {
      width: 200px;
      height: 320px;
      top: -368px;
      border-radius: 16px;
      .speed-label {
        width: 180px;
        height: 48px;
        line-height: 48px;
        font-size: 18px;
        padding-left: 36px;
        border-radius: 12px;
      }
    }
  }
}

// ========== PAD 及大屏 H5 变体适配（包含横向/竖向模式，覆盖 rem 为 px） ==========
// min-height: 500px 用于排除手机的横屏模式 (手机横屏 height 通常 < 450px)
@media screen and (min-width: 768px) and (min-height: 500px) {
  .speed-box__h5,
  .speed-box__h5-landscape {
    .speed-btn {
      width: 62px !important;
      font-size: 20px !important;
      line-height: 33px !important;
    }
    .speed-control {
      width: 192px !important;
      height: 300px !important;
      top: -348px !important;
      border-radius: 16px !important;
      padding: 6px 0 !important;
      .speed-label {
        margin-top: 4px !important;
        padding-left: 33px !important;
        width: 175px !important;
        height: 44px !important;
        line-height: 44px !important;
        border-radius: 12px !important;
        font-size: 18px !important;
      }
    }
  }
}
</style>

